import * as React from 'react';
import { Magnetic } from '@mitchell/react.component.ux';
import { TranslationService, EMPTY_TEXT } from "../../../common";
import { GPCLoaderConstants } from '../../constants';
import { PhotoCapture } from '../../enums';
import { StyledLoadingWrapper, StyledLogo, StyledLoadingText, StyledAnimatedDots } from './IntelligentProgressLoader.style';
export const IntelligentPhotoCaptureLoading = ({ logoSrc, altText = EMPTY_TEXT, loadingMessage = EMPTY_TEXT, title = EMPTY_TEXT, bgColor = `${Magnetic.colorGray}`, isMic = false }) => {
    const translateFn = TranslationService.translate;
    if (isMic) {
        return (React.createElement(StyledLoadingWrapper, { container: true, bgcolor: bgColor, id: `${PhotoCapture.GUIDED_PHOTO_CAPTURE}_IntelligentProgressLoader_LoadingWrapper`, direction: "column", justify: "center", alignItems: "center" },
            React.createElement(StyledLogo, { src: logoSrc, alt: translateFn(altText), id: `${PhotoCapture.GUIDED_PHOTO_CAPTURE}_loaderSrc` }),
            React.createElement(StyledLoadingText, { id: `${PhotoCapture.GUIDED_PHOTO_CAPTURE}_loadingText` }, translateFn(title)),
            React.createElement(StyledLoadingText, { id: `${PhotoCapture.GUIDED_PHOTO_CAPTURE}_loadingText` },
                translateFn(loadingMessage),
                React.createElement(StyledAnimatedDots, { id: `${PhotoCapture.GUIDED_PHOTO_CAPTURE}_animatedDots` }))));
    }
    else {
        return (React.createElement("div", { id: `${PhotoCapture.GUIDED_PHOTO_CAPTURE}_isloadingFalse` }, translateFn(GPCLoaderConstants.REDIRECTING)));
    }
};
export default IntelligentPhotoCaptureLoading;
//# sourceMappingURL=IntelligentProgressLoaderComponent.js.map